var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCroatia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e91",
    d: "M30 24H0v-8h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M19.6 13.41V7.96h-9.2v5.45a4.6 4.6 0 0 0 7.83 3.24 4.6 4.6 0 0 0 1.35-3.24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M20 7.56v5.85a5 5 0 0 1-8.52 3.52A5 5 0 0 1 10 13.41V7.56z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15 17.93a4.5 4.5 0 0 0 4.5-4.5v-5.4h-9v5.38a4.5 4.5 0 0 0 4.5 4.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.5 8 9.05.04v5.38a4.57 4.57 0 0 1-7.76 3.22 4.5 4.5 0 0 1-1.34-3.22z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M12.4 8.21h-1.73v1.9h1.73zm0 3.81h1.73v-1.9H12.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M10.67 13.41q0 .27.03.52h1.7v-1.9h-1.73zm5.2-1.39h-1.74v1.9h1.73z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M15.87 15.83h1.73v-1.9h-1.74z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M17.6 16.87q.58-.44.99-1.04h-1zm-5.2-1.04h1.73v-1.9H12.4zm-1 0q.42.6 1 1.04v-1.04z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "m15.3 17.73.56-.07v-1.83h-1.73v1.83q.59.11 1.17.07m4-3.8q.03-.25.03-.52v-1.39H17.6v1.9zm-3.44-1.9h1.74v-1.91h-1.74z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea3323",
    d: "M15.87 8.21h-1.74v1.9h1.73zm3.46 1.9v-1.9H17.6v1.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.43 7.9 1.07-2.44-.82-1.32-1.35.5-.96-1.08-1.25.72L15 3.36l-1.12.92-1.25-.72-.96 1.08-1.35-.5-.82 1.32 1.07 2.44a10.7 10.7 0 0 1 8.86 0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0093dd",
    d: "m11.7 4.75-1.34-.5-.76 1.22.3.66.72 1.66a11 11 0 0 1 1.7-.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e91",
    d: "m13.9 4.39-1.25-.71-.95 1.07.63 2.45a11 11 0 0 1 1.77-.3z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0093dd",
    d: "M16.11 4.39 15 3.49l-1.1.9.2 2.51a11 11 0 0 1 1.8 0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#100e91",
    d: "m18.3 4.75-.95-1.07-1.24.7-.2 2.52q.9.08 1.77.3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#0093dd",
    d: "m19.38 7.79 1.02-2.32-.76-1.21-1.34.5-.62 2.44q.88.22 1.7.59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatia);
export default __webpack_public_path__ + "static/media/croatia.d5e34b598d94164f00f7c2117d1665f2.svg";
export { ForwardRef as ReactComponent };